export default "__VITE_ASSET__CTR27Lsl__"